import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import MenuPage from './pages/MenuPage';
import ReservationPage from './pages/ReservationPage';
import ContactPage from './pages/ContactPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import MaintenanceOverlay from './components/MaintenanceOverlay';
import ScrollToTop from './components/ScrollToTop';
import { useState } from 'react';

const MAINTENANCE_MODE = false;

const AppWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
`;

function App() {
  const [showOverlay, setShowOverlay] = useState(MAINTENANCE_MODE);

  return (
    <AppWrapper>
      <ScrollToTop />

      {MAINTENANCE_MODE && showOverlay && (
        <MaintenanceOverlay onClose={() => setShowOverlay(false)} />
      )}

      <Navbar />

      <Main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/speisekarte" element={<MenuPage />} />
          <Route path="/reservierung" element={<ReservationPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
        </Routes>
      </Main>

      <Footer />
    </AppWrapper>
  );
}

export default App;